"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Layer = void 0;
var utils_1 = require("../utils");
var Layer = /** @class */ (function () {
    function Layer(_a) {
        var capabilities = _a.capabilities, debug = _a.debug, id = _a.id, layer = _a.layer, customFetch = _a.fetch;
        this.capabilities = Promise.resolve(capabilities);
        this.debug = debug;
        this.id = id;
        if (layer) {
            this.layer = Promise.resolve(layer);
        }
        this.fetch = customFetch || fetch;
        var _b = (0, utils_1.parseName)(id), namespace = _b.namespace, short = _b.short;
        this.namespace = namespace;
        this.name = short;
    }
    return Layer;
}());
exports.Layer = Layer;
